import { render, staticRenderFns } from "./vehicleequipmentDelivery.vue?vue&type=template&id=b92274aa&scoped=true"
import script from "./vehicleequipmentDelivery.vue?vue&type=script&lang=js"
export * from "./vehicleequipmentDelivery.vue?vue&type=script&lang=js"
import style0 from "./vehicleequipmentDelivery.vue?vue&type=style&index=0&id=b92274aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92274aa",
  null
  
)

export default component.exports